import { render, staticRenderFns } from "./VariantDetails.vue?vue&type=template&id=2946f9d8&"
import script from "./VariantDetails.vue?vue&type=script&lang=js&"
export * from "./VariantDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports